import { useStore } from "@nanostores/react";
import {
  brandSettings,
  paymentInfo as $paymentInfoAtom,
  totalCheckoutAmount,
} from "../../store/nanostore";
import { LoadingSpinner1 } from "../../pages/AddUserPage/AddUser";
import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import OtpField from "../../pages/Otp/OtpField";
import { PayBtn1 } from "./UserInfo";
import { usePlaidLink } from "react-plaid-link";
import { useMutation } from "@apollo/client";
import { MakePlaidTransferPayment } from "../../graphql/mutations/paymentlink";
import environment from "../../env";
import { toast } from "react-toastify";
import { useBankPaymentTokenization } from "../../services/tokenization/useBankPaymentTokenization";
import { useMakePayment } from "../../hooks/useMakePayment";
import { PaymentOTP } from "./PaymentOTP";
import { ListUserBankAccount } from "./ListUserBankAccount";
import { useCompletePayment } from "../../hooks/useCompletePayment";

export const PayWithBank = () => {
  const { error, isLoading, bankInfo } = useBankPaymentTokenization(undefined);
  const [request, makePayment] = useMakePayment();
  const [cRequest, completePayment] = useCompletePayment();
  const $paymentInfo = useStore($paymentInfoAtom);

  const [selectedAccount, setSelectedAccount] = useState<any>(null);
  const completePaymentData =
    cRequest?.data?.completePayment || cRequest?.data?.data?.completePayment;
  const completedPayment = completePaymentData?.status === "Payment successful";
  React.useEffect(() => {
    if (completedPayment) {
      toast.success("Payment successful", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // move this to a method
      window.location.href = `${window.location.origin}/p/${$paymentInfo.paymentIntent.reference}/status?method=stripe&paymentRef=${cRequest?.data.completePayment?.data?.transactionId}`;
    }
  }, [completedPayment]);

  // do look up, then save in atom, the loadAccount
  if (isLoading || cRequest.loading || request.loading) {
    return <LoadingSpinner1 />;
  }
  let errorMessage = (
    <span>
      {(error as any)?.message ||
        cRequest.error?.message ||
        request.error?.message}
    </span>
  );

  const handleInitPayment = (payload: any) => {
    //handleFormSubmit({ preventDefault: () => {} } as React.MouseEvent<HTMLButtonElement>)
    makePayment(payload);
    setSelectedAccount(payload.tokenId);
  };
  const handleOtpSubmit = async (otp: string[]) => {
    try {
      const initiatePayment =
        request?.data?.initiatePayment || request?.data?.data?.initiatePayment;
      const input = {
        emailOrPhone: {
          email: $paymentInfo?.payload?.email,
          phoneNumber: $paymentInfo?.payload?.phone,
        },
        idempotencyKey: initiatePayment?.idempotencyKey,
        oneTimePin: otp.join(""),
        requestId: initiatePayment?.requestId,
        tokenId: selectedAccount,
      };
      await completePayment(input);
    } catch (e) {
      toast.error("Invalid OTP or OTP expired", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleWebAuthSubmit = async (data: any) => {
    try {
      const initiatePayment =
        request?.data?.initiatePayment || request?.data?.data?.initiatePayment;
      const input = {
        emailOrPhone: {
          email: $paymentInfo?.payload?.email,
          phoneNumber: $paymentInfo?.payload?.phone,
        },
        credential: data,
        idempotencyKey: initiatePayment?.idempotencyKey,
        requestId: initiatePayment?.requestId,
        tokenId: selectedAccount,
      };
      await completePayment(input);
    } catch (e) {
      toast.error("Payment error", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  const initiatePayment =
    request?.data?.initiatePayment || request?.data?.data?.initiatePayment;

  return (
    <div>
      <span style={{ color: "red" }}>{errorMessage}</span>
      {typeof initiatePayment === "string" && (
        <span style={{ color: "red", margin: 5 }}>
          We are unable to process the selected account
        </span>
      )}
      {completedPayment && <span>Verifying payments. please wait</span>}
      {!completedPayment && initiatePayment?.idempotencyKey ? (
        <PaymentOTP
          to={$paymentInfo?.payload?.email}
          handleSubmit={handleOtpSubmit}
          handleWebAuthSubmit={handleWebAuthSubmit}
        />
      ) : (
        !completedPayment && (
          <ListUserBankAccount
            request={request}
            bankInfo={bankInfo}
            makePayment={handleInitPayment}
          />
        )
      )}
    </div>
  );
};

export const PayWithBankPayment = () => {
  const $paymentInfo = useStore($paymentInfoAtom);
  if ($paymentInfo.plaid.existingUser) {
    return <ShowOtpScreenForExistingUser />;
  }
  return <PlaidPaymentNewUser />;
};

export const PlaidPaymentNewUser = () => {
  const $paymentInfo = useStore($paymentInfoAtom);
  const $brandSettings = useStore(brandSettings);
  const [loading, setLoading] = useState(false);
  const [plaid, setPlaid] = useState<any>(null);

  const [attemptPlaidTransferPayment, { loading: submittingPlaidPayment }] =
    useMutation(MakePlaidTransferPayment, {
      variables: { ...environment.paymentService },
    });
  const { open, ready } = usePlaidLink({
    token: $paymentInfo.plaid?.link_token,
    onSuccess: (publicToken: any, metadata: any) => {
      setPlaid({ publicToken, metadata });
      setLoading(false);
    },
    onExit(error) {
      setLoading(false);
    },
  });

  const makePayment = async (publicToken: any, metadata: any) => {
    try {
      try {
        await attemptPlaidTransferPayment({
          variables: {
            payload: {
              amount: Number($paymentInfo?.productPrice || 100).toFixed(2),
              publicToken,
              name: $paymentInfo?.payload?.name,
              email: $paymentInfo?.payload?.email,
              phone: $paymentInfo?.payload?.phone,
              account_id: metadata.account_id,
              meta: { ...metadata, ...$paymentInfo?.payload },
            },
          },
        });
        // call backend
        // setPublicToken(public_token);
        // send public_token to server
        setLoading(false);
        window.location.href = `${window.location.origin}/p/${$paymentInfo?.paymentIntent?.reference}/status?method=plaid`;
      } catch (e) {
        toast.error("Could not complete payment");
      }
    } catch (e) {}
  };
  useEffect(() => {
    if (ready && !loading && open) {
      open();
      setLoading(true);
    }
  }, [ready]);

  return !ready ? (
    <CenterLoader />
  ) : (
    <>
      {(loading || submittingPlaidPayment) && <CenterLoader />}
      {!(loading || submittingPlaidPayment) && (
        <ButtonHandler
          backgroundColor={$brandSettings?.primaryColor}
          color={$brandSettings?.secondaryColor}
          title={plaid ? "Update Bank Account Linking" : "Link Bank Account"}
          onClick={open}
        />
      )}
      <br />
      {plaid && !submittingPlaidPayment && (
        <ButtonHandler
          backgroundColor={$brandSettings?.primaryColor}
          color={$brandSettings?.secondaryColor}
          title={"Complete Payment"}
          onClick={() => makePayment(plaid?.publicToken, plaid?.metadata)}
        />
      )}
    </>
  );
};

const ShowOtpScreenForExistingUser = () => {
  const $paymentInfo = useStore($paymentInfoAtom);
  const $brandSettings = useStore(brandSettings);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const size = 6;
  const handleOtp = () => {
    setLoading(!loading);
    window.location.href = `${window.location.origin}/p/${$paymentInfo?.paymentIntent?.reference}/status?method=plaid`;
  };

  return (
    <>
      <Content>
        <h4>Enter verification code sent to your email.</h4>
        <OtpField size={size} onChange={setOtp} />
        <PayBtn1
          css={`
            width: 100%;
            margin: 10px 0;
          `}
          backgroundColor={$brandSettings?.primaryColor}
          color={$brandSettings?.secondaryColor}
          onClick={handleOtp as any}
          $active={!loading && otp?.length === size}
        >
          {loading ? "Confirming" : "Verify OTP"}
        </PayBtn1>
      </Content>
    </>
  );
};

const ButtonHandler = ({ title, onClick, backgroundColor, color }: any) => (
  <PayBtn1
    css={`
      width: 100%;
      margin: 10px 0;
      padding: 10px;
    `}
    backgroundColor={backgroundColor}
    color={color}
    onClick={onClick as any}
    $active
  >
    {title || "Link Bank Account"}
  </PayBtn1>
);
export const CenterLoader = () => {
  return (
    <>
      <LoadingSpinner1 small />
    </>
  );
};

const Content = styled.div`
  padding: 20px;
`;
